<template>
  <div class="page-wrap">
    <el-card shadow="never" class="intro-card">
      <p class="intro-text">
        使用中遇到问题或有改进建议，请在此提交。可附上截图，管理员会尽快处理。
      </p>
    </el-card>

    <el-card shadow="never" style="margin-top:12px">
      <div slot="header"><span>提交反馈</span></div>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="问题或建议" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="6"
            maxlength="2000"
            show-word-limit
            placeholder="请描述您遇到的问题、复现步骤或改进建议…"
          />
        </el-form-item>
        <el-form-item label="上传截图">
          <el-upload
            action="#"
            list-type="picture-card"
            accept="image/*"
            :limit="5"
            :file-list="fileList"
            :http-request="uploadScreenshot"
            :on-remove="onRemoveImage"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <p class="upload-tip">最多 5 张，单张不超过 5MB，支持 jpg / png 等常见格式</p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submitting" @click="submit">提交反馈</el-button>
          <el-button @click="resetForm">清空</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never" style="margin-top:12px">
      <div slot="header"><span>我的反馈记录</span></div>
      <el-table :data="records" border stripe size="small" v-loading="loading">
        <el-table-column type="index" width="50" label="#" />
        <el-table-column prop="content" label="我的反馈" min-width="200" show-overflow-tooltip />
        <el-table-column label="管理员回复" min-width="200" show-overflow-tooltip>
          <template #default="{ row }">
            <span v-if="row.replyContent" class="reply-text">{{ row.replyContent }}</span>
            <span v-else class="muted">待回复</span>
          </template>
        </el-table-column>
        <el-table-column label="截图" width="120">
          <template #default="{ row }">
            <span v-if="!(row.imageUrls && row.imageUrls.length)">—</span>
            <el-button v-else type="text" size="mini" @click="previewImages(row.imageUrls)">
              {{ row.imageUrls.length }} 张
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template #default="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'warning'" size="mini">{{ row.statusLabel }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="提交时间" width="170">
          <template #default="{ row }">{{ formatTime(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template #default="{ row }">
            <el-button type="text" size="mini" @click="openDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > 0"
        style="margin-top:12px;text-align:right"
        small
        layout="total, prev, pager, next"
        :current-page="page + 1"
        :page-size="size"
        :total="total"
        @current-change="onPageChange"
      />
    </el-card>

    <el-dialog title="截图预览" :visible.sync="previewVisible" width="720px">
      <div class="preview-grid">
        <el-image
          v-for="(url, i) in previewUrls"
          :key="i"
          :src="url"
          :preview-src-list="previewUrls"
          fit="contain"
          class="preview-img"
        />
      </div>
    </el-dialog>

    <el-dialog title="反馈详情" :visible.sync="detailVisible" width="640px">
      <template v-if="detailRow">
        <div class="detail-block">
          <div class="detail-label">我的反馈</div>
          <div class="detail-body">{{ detailRow.content }}</div>
        </div>
        <div v-if="detailRow.replyContent" class="detail-block reply-block">
          <div class="detail-label">管理员回复<span v-if="detailRow.replyAt"> · {{ formatTime(detailRow.replyAt) }}</span></div>
          <div class="detail-body">{{ detailRow.replyContent }}</div>
        </div>
        <div v-else class="detail-block">
          <div class="detail-label muted">管理员尚未回复</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import teacherRequest from '../../utils/teacherRequest'

export default {
  name: 'TeacherFeedback',
  data() {
    return {
      form: { content: '' },
      rules: {
        content: [{ required: true, message: '请描述问题或建议', trigger: 'blur' }]
      },
      imageUrls: [],
      fileList: [],
      submitting: false,
      loading: false,
      records: [],
      page: 0,
      size: 10,
      total: 0,
      previewVisible: false,
      previewUrls: [],
      detailVisible: false,
      detailRow: null
    }
  },
  created() {
    this.loadRecords()
  },
  methods: {
    beforeUpload(file) {
      const isImage = file.type && file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    uploadScreenshot({ file, onSuccess, onError }) {
      const fd = new FormData()
      fd.append('file', file)
      teacherRequest.post('/upload/image', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(data => {
        const url = data.url
        this.imageUrls.push(url)
        this.fileList.push({ name: file.name, url, uid: file.uid })
        onSuccess(data)
      }).catch(err => {
        onError(err)
      })
    },
    onRemoveImage(file) {
      const url = file.url
      this.imageUrls = this.imageUrls.filter(u => u !== url)
      this.fileList = this.fileList.filter(f => f.url !== url)
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitting = true
        teacherRequest.post('/feedback', {
          content: this.form.content,
          imageUrls: this.imageUrls
        }).then(() => {
          this.$message.success('反馈已提交，感谢您的建议')
          this.resetForm()
          this.page = 0
          this.loadRecords()
        }).finally(() => { this.submitting = false })
      })
    },
    resetForm() {
      this.form.content = ''
      this.imageUrls = []
      this.fileList = []
      this.$refs.form && this.$refs.form.clearValidate()
    },
    loadRecords() {
      this.loading = true
      teacherRequest.get('/feedback', { params: { page: this.page, size: this.size } })
        .then(data => {
          this.records = data.content || []
          this.total = data.totalElements || 0
        })
        .catch(() => { this.records = [] })
        .finally(() => { this.loading = false })
    },
    onPageChange(val) {
      this.page = val - 1
      this.loadRecords()
    },
    formatTime(t) {
      if (!t) return '—'
      return String(t).replace('T', ' ').slice(0, 19)
    },
    previewImages(urls) {
      this.previewUrls = urls || []
      this.previewVisible = true
    },
    openDetail(row) {
      this.detailRow = row
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.intro-card { background: #f7f9fc; border: 1px solid #e8ecf4; }
.intro-text { margin: 0; color: #555; font-size: 14px; line-height: 1.6; }
.upload-tip { margin: 8px 0 0; font-size: 12px; color: #999; }
.preview-grid { display: flex; flex-wrap: wrap; gap: 12px; }
.preview-img { width: 200px; height: 140px; border: 1px solid #eee; border-radius: 4px; }
.reply-text { color: #389e0d; }
.muted { color: #bbb; }
.detail-block { margin-bottom: 16px; }
.detail-label { font-size: 13px; font-weight: 600; color: #666; margin-bottom: 8px; }
.detail-body { white-space: pre-wrap; line-height: 1.7; font-size: 14px; color: #333; padding: 12px; background: #f7f9fc; border-radius: 6px; }
.reply-block .detail-body { background: #f0f9eb; border: 1px solid #d9f7be; }
</style>
